var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('points-table',{attrs:{"customers":_vm.records,"headers":_vm.headers},on:{"refresh":_vm.getRecords}},[_vm._v("Manage Deleted Records")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }